// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__17glk","legacyBtn":"MutateMid_legacyBtn__1Gv1t"};